import React from 'react';
import dayjs from 'dayjs';
import { DateField } from '@sitecore-jss/sitecore-jss-react';

const toDateString = (date): any => (<span>
 {
    date.getUTCFullYear() != "1" &&
  dayjs(date.getUTCFullYear() + '-' + (date.getUTCMonth() + 1) + '-' + date.getUTCDate()).format('MMMM D, YYYY')}
</span>);

const ArticleDate = props => (
  <DateField {...props} render={toDateString} />
);

export { ArticleDate };